const commonTabs = [
  {
    key: "general",
    label: "General",
  },
  {
    key: "organization",
    label: "Organization",
    conditionalRenderSelector: "getProfileOrganizationTabVisible",
  },
  {
    key: "reset-password",
    label: "Reset Password",
  },
  {
    key: "e-wallet",
    label: "E-wallet",
  },
  {
    key: "service-areas",
    label: "Service Areas & Licenses",
  },
  {
    key: "finance-partners",
    label: "Finance Partner Onboarding",
  },
  {
    key: "sales-partner",
    label: "Mentor",
    conditionalRenderSelector: "getProfileMentorshipTabVisible",
  },
  {
    key: "achievements-and-certifications",
    label: "Achievements",
  },
];

const adminTabs = [];

export { commonTabs, adminTabs };

export default [...commonTabs, ...adminTabs];
